import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  audienceLoadSuccess,
  audienceLoadFailure,
  audienceSaveSuccess,
  audienceSaveFailure,
  redirect,
  addNotification,
  audienceDeleteFailure,
  audienceDeleteSuccess
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* audienceLoadSaga() {
  try {
    const result = yield axios.get(uris.audience)
    yield put(audienceLoadSuccess(result.data))
  } catch (error) {
    yield put(audienceLoadFailure(uiHelper.errorMessage(error)))
  }
}

export function* audienceSaveSaga(action) {
  try {
    const body = { ...action.payload }
    let url = uris.audience
    let method = 'post'
    if (action.payload.id) {
      url += `/${action.payload.id}`
      method = 'put'
    }
    delete body.id
    const result = yield axios({
      method,
      url,
      data: body
    })
    yield put(audienceSaveSuccess(result.data))

    if (!action.payload.id) {
      const [, id] = uiHelper.location()
      yield put(redirect(`/${id}/audiences/${result.data._id}`))
    }
    yield put(
      addNotification(
        action.payload.id
          ? uiConstants.messages.audience_updated
          : uiConstants.messages.audience_created
      )
    )
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(audienceSaveFailure(uiHelper.errorMessage(error)))
  }
}

export function* audienceDeleteSaga(action) {
  try {
    yield axios.delete(`${uris.audience}/${action.payload}`)
    const [, id] = uiHelper.location()
    yield put(redirect(`/${id}/audiences`))
    yield put(audienceDeleteSuccess(action.payload))
    yield put(addNotification(uiConstants.messages.audience_deleted))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(audienceDeleteFailure(uiHelper.errorMessage(error)))
  }
}
